import {Layout} from 'antd'
import React from 'react'


const {Footer} = Layout
const SpadasFooter = () => {
    return <Footer theme='dark' style={{textAlign: 'center'}}>Spadas ©2025 Created by <a href="http://sheng.whu.edu.cn">Sheng's
        Group</a></Footer>
}

export default SpadasFooter
